import Translation from "components/Translation";
import InputValidations from "components/Validations/Field";
import React from "react";
import { FieldError } from "react-hook-form";
import { classNames } from "utils/dom-helpers";

export type FormInputProps = {
    children: React.ReactElement
    fieldError?: FieldError | undefined
    htmlFor?: string
    label: string
    required?: boolean
    required_key?: string
    pattern_key?: string
    maxlength_key?: string
    minlength_key?: string
    className?: string
}

export default function FormInput({
    label,
    htmlFor,
    required,
    required_key,
    pattern_key,
    maxlength_key,
    minlength_key,
    fieldError,
    children,
    className
} : FormInputProps) {

    const inputClassNames = classNames(children.props.className ||
        'mt-1 focus:ring-primary-light focus:border-primary-light block w-full shadow-sm border-gray-300 rounded-md',
        fieldError?.type
            ? 'border-red-300 bg-red-100'
            : '',
        children.props.type == 'text'
            ? 'px-6 py-3'
            : ''
    )

    return (
        <>
            <label
                htmlFor={htmlFor}
                className={classNames(
                    'block text-sm',
                    fieldError?.type ? 'text-red-700' : ''
                )}
            >
                <Translation content_key={label} />
                {(required_key || required) && <span className="text-red-500 ml-1">*</span>}
            </label>
            
            {React.cloneElement(children, { 
                id: htmlFor,
                className: inputClassNames
            })}

            <InputValidations 
                field_error={fieldError}
                required_key={required_key}
                pattern_key={pattern_key}
                maxlength_key={maxlength_key}
                minlength_key={minlength_key}
                className={className}
            />
        </>
    )
}